import BusinessDetails from "./businessDetails";
export default BusinessDetails;